import { render, staticRenderFns } from "./WebhooksPage.vue?vue&type=template&id=3dedaf08&"
import script from "./WebhooksPage.vue?vue&type=script&lang=js&"
export * from "./WebhooksPage.vue?vue&type=script&lang=js&"
import style0 from "./WebhooksPage.vue?vue&type=style&index=0&id=3dedaf08&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports